export const Translation = {
	USER_NAV_ARIALABEL: 'userNav.ariaLabel',
	USER_NAV_PROFILE: 'userNav.profile',
	USER_NAV_YOUR_DEBIT_CARD: 'userNav.yourDebitCard',
	USER_NAV_YOUR_TRANSACTIONS: 'userNav.yourTransactions',

	COMPANY_NAV_ARIALABEL: 'companyNav.ariaLabel',
	COMPANY_NAV_COMPANY_PROFILE: 'companyNav.companyProfile',
	COMPANY_NAV_EMPLOYEES: 'companyNav.employees',
	COMPANY_NAV_DEBIT_CARDS: 'companyNav.debitCards',
	COMPANY_NAV_BENEFITS: 'companyNav.benefits',
	COMPANY_NAV_TOPUP_ORDERS: 'companyNav.topupOrders',
	COMPANY_NAV_TOPUPS: 'companyNav.topups',

	SIDEBAR_FULL_ASIDE_LABEL: 'sidebar.fullAsideLabel',
	SIDEBAR_COMPACT_ASIDE_LABEL: 'sidebar.compacAsideLabel',

	FEEDBACK_TITLE: 'feedback.title',
	FEEDBACK_BUTTON: 'feedback.button',

	LOGOUT_SIGN_OUT: 'logOut.signOut',
	LOGOUT_SUCCESS: 'logOut.success',
	LOGOUT_ERROR: 'logOut.error',

	NETWORK_STATUS_OFFLINE: 'networkStatus.offline',
	NETWORK_STATUS_ONLINE: 'networkStatus.online',

	NOTFOUND_TITLE: 'notFoundPage.title',
	NOTFOUND_LINK_TEXT: 'notFoundPage.linkText',

	HOME_SIGN_IN: 'home.signIn',
	HOME_SIGN_IN_LOADING: 'home.signInLoading',
	HOME_LOGO_ARIA: 'home.logoAria',
	HOME_AUTH_FAILED: 'home.authFailed',
	HOME_LOGGED_OUT_TITLE: 'home.loggedOutTitle',

	LOGINFORM_PHONE: 'loginForm.phone',
	LOGINFORM_SUBMIT: 'loginForm.submit',
	LOGINFORM_SUBMIT_LOADING: 'loginForm.submitLoading',
	LOGINFORM_MINIBROWSER_TITLE: 'loginForm.miniBrowserTitle',
	LOGINFORM_MINIBROWSER_CANCEL: 'loginForm.miniBrowserCancel',
	LOGINFORM_MANUAL_TOKEN_TITLE: 'loginForm.manualTokenTitle',
	LOGINFORM_MANUAL_TOKEN_HINT: 'loginForm.manualTokenHint',
	LOGINFORM_MANUAL_TOKEN_PLACEHOLDER: 'loginForm.manualTokenPlaceholder',
	LOGINFORM_MANUAL_TOKEN_SUBMIT: 'loginForm.manualTokenSubmit',
	LOGINFORM_AUTH_FAILED: 'loginForm.authFailed',

	COLLAPSEMENUBUTTON_ARIA_COLLAPSE: 'collapseMenuButton.ariaCollapse',
	COLLAPSEMENUBUTTON_ARIA_EXPAND: 'collapseMenuButton.ariaExpand',

	SENSITIVE_DATA_BUTTON_SHOW: 'sensitiveDataButton.show',
	SENSITIVE_DATA_BUTTON_HIDE: 'sensitiveDataButton.hide',

	LANGUAGESWITCHER_LANGUAGE: 'languageSwitcher.language',
	LANGUAGESWITCHER_ARIA_PREFIX: 'languageSwitcher.ariaPrefix',
	LANGUAGESWITCHER_ARIA_SUFFIX: 'languageSwitcher.ariaSuffix',
	LANGUAGESWITCHER_SAVE_ERROR: 'languageSwitcher.saveError',

	LOGO_ALT: 'logo.alt',
	LOGO_ARIA: 'logo.aria',

	LOADER_LABEL: 'loader.label',

	EMPLOYEES_ACTIONS_SECTION_TITLE: 'employeesActions.sectionTitle',
	EMPLOYEES_ACTIONS_ADD_EMPLOYEE: 'employeesActions.addEmployee',
	EMPLOYEES_ACTIONS_DEACTIVATE: 'employeesActions.deactivate',
	EMPLOYEES_ACTIONS_SELECTED: 'employeesActions.selected',
	EMPLOYEES_ACTIONS_SEARCH_PLACEHOLDER: 'employeesActions.searchPlaceholder',
	EMPLOYEES_ACTIONS_CLEAR_SELECTION: 'employeesActions.clearSelection',
	EMPLOYEES_ACTIONS_DEACTIVATE_SUCCESS: 'employeesActions.deactivateSuccess',
	EMPLOYEES_ACTIONS_DEACTIVATE_ERROR: 'employeesActions.deactivateError',

	EMPLOYEES_DEACTIVATE_MODAL_TITLE: 'employeesDeactivateModal.title',
	EMPLOYEES_DEACTIVATE_MODAL_NOTIFICATION: 'employeesDeactivateModal.notification',
	EMPLOYEES_DEACTIVATE_MODAL_CLOSE: 'employeesDeactivateModal.close',
	EMPLOYEES_DEACTIVATE_MODAL_CONFIRM: 'employeesDeactivateModal.confirm',

	EMPLOYEE_MODAL_TITLE: 'employeeModal.title',
	EMPLOYEE_MODAL_CLOSE: 'employeeModal.close',
	EMPLOYEE_MODAL_SAVE: 'employeeModal.save',
	EMPLOYEE_MODAL_DEACTIVATE: 'employeeModal.deactivate',

	EMPLOYEE_MODAL_TAB_DETAILS: 'employeeModal.tabs.details',
	EMPLOYEE_MODAL_TAB_DEBITCARD: 'employeeModal.tabs.debitcard',
	EMPLOYEE_MODAL_DEBITCARD_NO_CARD: 'employeeModal.debitcard.noCard',
	EMPLOYEE_MODAL_DEBITCARD_CARDS_LIST_LABEL: 'employeeModal.debitcard.cardsListLabel',
	EMPLOYEE_MODAL_DEBITCARD_CONVERT: 'employeeModal.debitcard.convert',
	EMPLOYEE_MODAL_DEBITCARD_CONVERT_MODAL_TITLE: 'employeeModal.debitcard.convertModalTitle',
	EMPLOYEE_MODAL_DEBITCARD_CONVERT_CONFIRM: 'employeeModal.debitcard.convertConfirm',
	EMPLOYEE_MODAL_DEBITCARD_CONVERT_SUCCESS: 'employeeModal.debitcard.convertSuccess',
	EMPLOYEE_MODAL_DEBITCARD_CONVERT_ERROR: 'employeeModal.debitcard.convertError',
	EMPLOYEE_MODAL_DEBITCARD_CONVERT_ERROR_NOT_VIRTUAL: 'employeeModal.debitcard.convertErrors.notVirtual',
	EMPLOYEE_MODAL_DEBITCARD_CONVERT_ERROR_NOT_ACTIVE: 'employeeModal.debitcard.convertErrors.notActive',
	EMPLOYEE_MODAL_DEBITCARD_CONVERT_ERROR_ALREADY_CONVERTED: 'employeeModal.debitcard.convertErrors.alreadyConverted',
	EMPLOYEE_MODAL_DEBITCARD_CONVERT_ERROR_NOT_ALLOWED: 'employeeModal.debitcard.convertErrors.notAllowed',
	EMPLOYEE_MODAL_DEBITCARD_CONVERT_ERROR_ADDRESS: 'employeeModal.debitcard.convertErrors.address',
	EMPLOYEE_MODAL_DEBITCARD_CONVERT_ERROR_UNKNOWN_OUTCOME: 'employeeModal.debitcard.convertErrors.unknownOutcome',
	EMPLOYEE_MODAL_DEBITCARD_CONVERT_UNCONFIRMED: 'employeeModal.debitcard.convertUnconfirmed',
	EMPLOYEE_MODAL_DEBITCARD_CANCEL_CARD: 'employeeModal.debitcard.cancelCard',
	EMPLOYEE_MODAL_DEBITCARD_FREEZE_CARD: 'employeeModal.debitcard.freezeCard',
	EMPLOYEE_MODAL_DEBITCARD_UNFREEZE_CARD: 'employeeModal.debitcard.unfreezeCard',
	EMPLOYEE_MODAL_DEBITCARD_CARD_UNAVAILABLE: 'employeeModal.debitcard.cardUnavailable',
	EMPLOYEE_MODAL_DEBITCARD_CARD_RETRY: 'employeeModal.debitcard.cardRetry',
	EMPLOYEE_MODAL_TAB_BENEFITS: 'employeeModal.tabs.benefits',
	EMPLOYEE_MODAL_TAB_PERMISSIONS: 'employeeModal.tabs.permissions',

	EMPLOYEE_MODAL_NAV_PREV: 'employeeModal.nav.prev',
	EMPLOYEE_MODAL_NAV_NEXT: 'employeeModal.nav.next',
	EMPLOYEE_MODAL_NAV_TABS_LABEL: 'employeeModal.nav.tabsLabel',

	EMPLOYEE_MODAL_SAVE_SUCCESS: 'employeeModal.saveSuccess',
	EMPLOYEE_MODAL_SAVE_ERROR: 'employeeModal.saveError',
	EMPLOYEE_MODAL_BENEFITS_SAVE_SUCCESS: 'employeeModal.benefitsSaveSuccess',
	EMPLOYEE_MODAL_BENEFITS_SAVE_ERROR: 'employeeModal.benefitsSaveError',
	EMPLOYEE_MODAL_DEACTIVATE_SUCCESS: 'employeeModal.deactivateSuccess',
	EMPLOYEE_MODAL_DEACTIVATE_ERROR: 'employeeModal.deactivateError',

	EMPLOYEE_MODAL_FIELD_FIRST_NAME: 'employeeModal.fields.firstName',
	EMPLOYEE_MODAL_FIELD_LAST_NAME: 'employeeModal.fields.lastName',
	EMPLOYEE_MODAL_FIELD_EMAIL: 'employeeModal.fields.email',
	EMPLOYEE_MODAL_FIELD_PHONE: 'employeeModal.fields.phone',
	EMPLOYEE_MODAL_FIELD_BIRTH_DATE: 'employeeModal.fields.birthDate',
	EMPLOYEE_MODAL_FIELD_EMPLOYEE_ID: 'employeeModal.fields.employeeId',
	EMPLOYEE_MODAL_FIELD_EMPLOYEE_ENTRY_DATE: 'employeeModal.fields.employeeEntryDate',

	EMPLOYEE_MODAL_PERMISSION_SECTION_TITLE: 'employeeModal.permission.sectionTitle',
	EMPLOYEE_MODAL_PERMISSION_ADMIN_LABEL: 'employeeModal.permission.adminLabel',
	EMPLOYEE_MODAL_PERMISSION_ADMIN_DESC: 'employeeModal.permission.adminDesc',

	EMPLOYEE_MODAL_BENEFITS_SECTION_TITLE: 'employeeModal.benefits.sectionTitle',
	EMPLOYEE_MODAL_BENEFITS_COL_BENEFIT: 'employeeModal.benefits.colBenefit',
	EMPLOYEE_MODAL_BENEFITS_COL_REGION: 'employeeModal.benefits.colRegion',
	EMPLOYEE_MODAL_BENEFITS_EMPTY_TITLE: 'employeeModal.benefits.emptyTitle',
	EMPLOYEE_MODAL_BENEFITS_EMPTY_DESCRIPTION: 'employeeModal.benefits.emptyDescription',
	EMPLOYEE_MODAL_BENEFITS_REIMBURSEMENT_DESCRIPTION:
		'employeeModal.benefits.reimbursement.description',

	COMPANY_PROFILE_TABLIST_ARIA_LABEL: 'companyProfile.tablistAriaLabel',
	COMPANY_PROFILE_NOT_SPECIFIED: 'companyProfile.notSpecified',

	COMPANY_PROFILE_ACCOUNT_SECTION_TITLE: 'companyProfile.account.sectionTitle',
	COMPANY_PROFILE_ACCOUNT_AVAILABLE_BALANCE: 'companyProfile.account.availableBalance',
	COMPANY_PROFILE_ACCOUNT_IBAN: 'companyProfile.account.iban',
	COMPANY_PROFILE_ACCOUNT_ONBOARDING_NOTIFICATION_TITLE:
		'companyProfile.account.onboardingNotification.title',
	COMPANY_PROFILE_ACCOUNT_ONBOARDING_NOTIFICATION_DESCRIPTION:
		'companyProfile.account.onboardingNotification.description',

	COMPANY_PROFILE_NOTIFICATION_SECTION_TITLE: 'companyProfile.notification.sectionTitle',
	COMPANY_PROFILE_NOTIFICATION_ACCOUNTING_EMAIL: 'companyProfile.notification.accountingEmail',
	COMPANY_PROFILE_NOTIFICATION_ADD_EMAIL_BUTTON: 'companyProfile.notification.addEmailButton',
	COMPANY_PROFILE_NOTIFICATION_EMAIL_MODAL_TITLE: 'companyProfile.notification.emailModal.title',
	COMPANY_PROFILE_NOTIFICATION_EMAIL_MODAL_CLOSE: 'companyProfile.notification.emailModal.close',
	COMPANY_PROFILE_NOTIFICATION_EMAIL_MODAL_CONFIRM:
		'companyProfile.notification.emailModal.confirm',
	COMPANY_PROFILE_NOTIFICATION_EMAIL_MODAL_FIELD_LABEL:
		'companyProfile.notification.emailModal.fieldLabel',
	COMPANY_PROFILE_NOTIFICATION_EMAIL_SAVED: 'companyProfile.notification.emailSaved',
	COMPANY_PROFILE_NOTIFICATION_EMAIL_SAVE_ERROR: 'companyProfile.notification.emailSaveError',

	COMPANY_PROFILE_MANDAT_SECTION_TITLE: 'companyProfile.mandat.sectionTitle',
	COMPANY_PROFILE_MANDAT_STATUS: 'companyProfile.mandat.mandateStatus',
	COMPANY_PROFILE_MANDAT_REFERENCE: 'companyProfile.mandat.mandateReference',
	COMPANY_PROFILE_MANDAT_DOCUMENT: 'companyProfile.mandat.mandateDocument',
	COMPANY_PROFILE_MANDAT_SHOW_DOCUMENT: 'companyProfile.mandat.showDocument',
	COMPANY_PROFILE_MANDAT_EXTERNAL_BANK_CONFIRMED: 'companyProfile.mandat.externalBankConfirmed',
	COMPANY_PROFILE_MANDAT_CONFIRMED: 'companyProfile.mandat.confirmed',
	COMPANY_PROFILE_MANDAT_NOT_CONFIRMED: 'companyProfile.mandat.notConfirmed',
	COMPANY_PROFILE_MANDAT_DIRECT_DEBIT: 'companyProfile.mandat.directDebitMandate',
	COMPANY_PROFILE_MANDAT_RETRY: 'companyProfile.mandat.retry',
	COMPANY_PROFILE_MANDAT_ERROR_MESSAGE: 'companyProfile.mandat.errorMessage',
	COMPANY_PROFILE_ADDRESS_SAVED: 'companyProfile.addressSaved',
	COMPANY_PROFILE_ADDRESS_SAVE_ERROR: 'companyProfile.addressSaveError',
	COMPANY_PROFILE_ADDRESS_LABEL: 'companyProfile.addressLabel',
	COMPANY_PROFILE_ADDRESS_MODAL_TITLE: 'companyProfile.addressModalTitle',

	COMPANY_PROFILE_TAB_ACCOUNT: 'companyProfile.tabs.account',
	COMPANY_PROFILE_TAB_DIRECT_DEBIT: 'companyProfile.tabs.directDebit',
	COMPANY_PROFILE_TAB_NOTIFICATIONS: 'companyProfile.tabs.notifications',
	COMPANY_PROFILE_TAB_ADMINS: 'companyProfile.tabs.admins',

	EMPLOYEES_COMPANY_SECTION_TITLE: 'employeesCompany.sectionTitle',

	EMPLOYEES_COMPANY_COL_FULL_NAME: 'employeesCompany.columns.fullName',
	EMPLOYEES_COMPANY_COL_EMPLOYEE_ID: 'employeesCompany.columns.employeeId',
	EMPLOYEES_COMPANY_COL_EMAIL: 'employeesCompany.columns.email',
	EMPLOYEES_COMPANY_COL_PHONE: 'employeesCompany.columns.phone',

	EMPLOYEE_STATUS_NEW: 'employeeStatus.new',
	EMPLOYEE_STATUS_INVITED: 'employeeStatus.invited',
	EMPLOYEE_STATUS_VERIFIED: 'employeeStatus.verified',
	EMPLOYEE_STATUS_IDENTIFIED: 'employeeStatus.identified',

	PROFILE_USER_BENEFITS_SECTION_TITLE: 'profileUserBenefits.sectionTitle',
	PROFILE_USER_BENEFITS_EDIT_ARIA: 'profileUserBenefits.editAria',
	PROFILE_USER_BENEFITS_EMPTY: 'profileUserBenefits.empty',
	PROFILE_USER_BENEFITS_COL_BENEFIT: 'profileUserBenefits.columns.benefit',
	PROFILE_USER_BENEFITS_COL_BALANCE: 'profileUserBenefits.columns.balance',
	PROFILE_USER_BENEFITS_COL_TAX_RELIEFS: 'profileUserBenefits.columns.taxReliefs',

	PROFILE_USER_BENEFITS_EDIT_MODAL_SECTION_TITLE: 'profileUserBenefits.editModal.sectionTitle',
	PROFILE_USER_BENEFITS_EDIT_MODAL_TITLE: 'profileUserBenefits.editModal.title',
	PROFILE_USER_BENEFITS_EDIT_MODAL_DESCRIPTION: 'profileUserBenefits.editModal.description',
	PROFILE_USER_BENEFITS_EDIT_MODAL_PLACEHOLDER: 'profileUserBenefits.editModal.placeholder',
	PROFILE_USER_BENEFITS_EDIT_MODAL_CONFIRM_TEXT: 'profileUserBenefits.editModal.confirmText',
	PROFILE_USER_BENEFITS_EDIT_MODAL_CLOSE: 'profileUserBenefits.editModal.close',
	PROFILE_USER_BENEFITS_EDIT_MODAL_SUCCESS: 'profileUserBenefits.editModal.success',
	PROFILE_USER_BENEFITS_EDIT_MODAL_ERROR: 'profileUserBenefits.editModal.error',
	PROFILE_USER_BENEFITS_EDIT_MODAL_SAVE: 'profileUserBenefits.editModal.save',

	TRANSACTIONS_USER_SECTION_TITLE: 'transactionsUser.sectionTitle',
	TRANSACTIONS_USER_COL_TRANSACTION: 'transactionsUser.columns.transaction',
	TRANSACTIONS_USER_COL_DESCRIPTION: 'transactionsUser.columns.description',
	TRANSACTIONS_USER_COL_DATE: 'transactionsUser.columns.date',
	TRANSACTIONS_USER_COL_AMOUNT: 'transactionsUser.columns.amount',
	TRANSACTIONS_USER_EMPTY_STATE: 'transactionsUser.emptyState',

	COMPANY_PROFILE_ADMINS_SECTION_TITLE: 'companyProfileAdmins.sectionTitle',
	COMPANY_PROFILE_ADMINS_ADD_BUTTON: 'companyProfileAdmins.addButton',
	COMPANY_PROFILE_ADMINS_COL_FIRST_NAME: 'companyProfileAdmins.columns.firstName',
	COMPANY_PROFILE_ADMINS_COL_LAST_NAME: 'companyProfileAdmins.columns.lastName',
	COMPANY_PROFILE_ADMINS_COL_EMAIL: 'companyProfileAdmins.columns.email',
	COMPANY_PROFILE_ADMINS_COL_PHONE: 'companyProfileAdmins.columns.phone',
	COMPANY_PROFILE_ADMINS_COL_IS_ACCOUNT_OWNER: 'companyProfileAdmins.columns.isAccountOwner',
	COMPANY_PROFILE_ADMINS_ACCOUNT_OWNER_YES: 'companyProfileAdmins.accountOwner.yes',
	COMPANY_PROFILE_ADMINS_ACCOUNT_OWNER_NO: 'companyProfileAdmins.accountOwner.no',
	COMPANY_PROFILE_ADMINS_COPY_PHONE_ARIA: 'companyProfileAdmins.copyPhoneAria',
	COMPANY_PROFILE_ADMINS_DELETE_ACTION_ARIA: 'companyProfileAdmins.deleteAction.aria',
	COMPANY_PROFILE_ADMINS_DELETE_MODAL_TITLE: 'companyProfileAdmins.deleteModal.title',
	COMPANY_PROFILE_ADMINS_DELETE_MODAL_NOTIFICATION: 'companyProfileAdmins.deleteModal.notification',
	COMPANY_PROFILE_ADMINS_DELETE_MODAL_CLOSE: 'companyProfileAdmins.deleteModal.close',
	COMPANY_PROFILE_ADMINS_DELETE_MODAL_CONFIRM: 'companyProfileAdmins.deleteModal.confirm',

	EMPLOYEES_ADD_MODAL_SECTION_TITLE: 'employeesAddModal.sectionTitle',
	EMPLOYEES_ADD_MODAL_TITLE: 'employeesAddModal.title',
	EMPLOYEES_ADD_MODAL_DESCRIPTION: 'employeesAddModal.description',
	EMPLOYEES_ADD_MODAL_CANCEL: 'employeesAddModal.cancel',
	EMPLOYEES_ADD_MODAL_CONFIRM: 'employeesAddModal.confirm',
	EMPLOYEES_ADD_MODAL_BACK: 'employeesAddModal.back',
	EMPLOYEES_ADD_MODAL_SUBMIT: 'employeesAddModal.submit',
	EMPLOYEES_ADD_MODAL_SUBMIT_ERROR: 'employeesAddModal.submitError',
	EMPLOYEES_ADD_MODAL_CLOSE: 'employeesAddModal.close',
	EMPLOYEES_ADD_MODAL_SUCCESS: 'employeesAddModal.success',
	EMPLOYEES_ADD_MODAL_STEP2_SECTION_TITLE: 'employeesAddModal.step2.sectionTitle',
	EMPLOYEES_ADD_MODAL_STEP2_DESCRIPTION: 'employeesAddModal.step2.description',
	EMPLOYEES_ADD_MODAL_STEP2_GROUP_LABEL: 'employeesAddModal.step2.groupLabel',
	EMPLOYEES_ADD_MODAL_STEP2_GROUP_DESC: 'employeesAddModal.step2.groupDesc',
	EMPLOYEES_ADD_MODAL_STEP2_GROUP_PLACEHOLDER: 'employeesAddModal.step2.groupPlaceholder',
	EMPLOYEES_ADD_MODAL_STEP2_GROUP_PLACEHOLDER_EMPTY:
		'employeesAddModal.step2.groupPlaceholderEmpty',
	EMPLOYEES_ADD_MODAL_STEP2_BENEFITS_TITLE: 'employeesAddModal.step2.benefitsTitle',

	COMPANY_PROFILE_ADMINS_ADD_MODAL_TITLE: 'companyProfileAdmins.addModal.title',
	COMPANY_PROFILE_ADMINS_ADD_MODAL_FIELD_FIRST_NAME:
		'companyProfileAdmins.addModal.fields.firstName',
	COMPANY_PROFILE_ADMINS_ADD_MODAL_FIELD_LAST_NAME: 'companyProfileAdmins.addModal.fields.lastName',
	COMPANY_PROFILE_ADMINS_ADD_MODAL_FIELD_PHONE: 'companyProfileAdmins.addModal.fields.phone',
	COMPANY_PROFILE_ADMINS_ADD_MODAL_FIELD_EMAIL: 'companyProfileAdmins.addModal.fields.email',
	COMPANY_PROFILE_ADMINS_ADD_MODAL_FIELD_BIRTH_DATE:
		'companyProfileAdmins.addModal.fields.birthDate',
	COMPANY_PROFILE_ADMINS_ADD_MODAL_CLOSE: 'companyProfileAdmins.addModal.close',
	COMPANY_PROFILE_ADMINS_ADD_MODAL_CONFIRM: 'companyProfileAdmins.addModal.confirm',
	COMPANY_PROFILE_ADMINS_ERROR: 'companyProfileAdmins.error',

	BENEFITS_MATRIX_SECTION_TITLE: 'benefitsMatrix.sectionTitle',
	BENEFITS_MATRIX_SEARCH_PLACEHOLDER: 'benefitsMatrix.searchPlaceholder',
	BENEFITS_MATRIX_LEGEND_TITLE: 'benefitsMatrix.legendTitle',
	BENEFITS_MATRIX_SELECTED: 'benefitsMatrix.selected',
	BENEFITS_MATRIX_CLEAR_SELECTION: 'benefitsMatrix.clearSelection',
	BENEFITS_MATRIX_DROPDOWN_ASSIGN_LABEL: 'benefitsMatrix.dropdownAssignLabel',
	BENEFITS_MATRIX_DROPDOWN_SHOW_LABEL: 'benefitsMatrix.dropdownShowLabel',
	BENEFITS_MATRIX_DROPDOWN_ASSIGN_TO_SELECTED: 'benefitsMatrix.dropdownAssignToSelected',
	BENEFITS_MATRIX_DROPDOWN_ASSIGN_MISSING: 'benefitsMatrix.dropdownAssignMissing',
	BENEFITS_MATRIX_DROPDOWN_SHOW_ASSIGNED: 'benefitsMatrix.dropdownShowAssigned',
	BENEFITS_MATRIX_DROPDOWN_SHOW_MISSING: 'benefitsMatrix.dropdownShowMissing',
	BENEFITS_MATRIX_DROPDOWN_SHOW_ALL: 'benefitsMatrix.dropdownShowAll',
	BENEFITS_MATRIX_COL_EMPLOYEES: 'benefitsMatrix.colEmployees',
	BENEFITS_MATRIX_CELL_ADD: 'benefitsMatrix.cellAdd',
	BENEFITS_MATRIX_CELL_EDIT: 'benefitsMatrix.cellEdit',

	BENEFITS_MATRIX_MODAL_TITLE: 'benefitsMatrix.modal.title',
	BENEFITS_MATRIX_MODAL_DESCRIPTION: 'benefitsMatrix.modal.description',
	BENEFITS_MATRIX_MODAL_SELECT_CARD: 'benefitsMatrix.modal.selectCard',
	BENEFITS_MATRIX_MODAL_REGION_LABEL: 'benefitsMatrix.modal.regionLabel',
	BENEFITS_MATRIX_MODAL_REGION_DESCRIPTION: 'benefitsMatrix.modal.regionDescription',
	BENEFITS_MATRIX_MODAL_REGION_PLACEHOLDER: 'benefitsMatrix.modal.regionPlaceholder',
	BENEFITS_MATRIX_MODAL_CANCEL: 'benefitsMatrix.modal.cancel',
	BENEFITS_MATRIX_MODAL_SUBMIT: 'benefitsMatrix.modal.submit',
	BENEFITS_MATRIX_MODAL_EMPLOYEE_COUNT: 'benefitsMatrix.modal.employeeCount',
	BENEFITS_MATRIX_MODAL_EDIT_TITLE: 'benefitsMatrix.modal.editTitle',
	BENEFITS_MATRIX_MODAL_EDIT_SUBMIT: 'benefitsMatrix.modal.editSubmit',
	BENEFITS_MATRIX_MODAL_ERROR: 'benefitsMatrix.modal.error',
	BENEFITS_MATRIX_MODAL_NO_CONFIGS: 'benefitsMatrix.modal.noConfigs',

	CARD_STATUS_TO_ACTIVATE: 'cardStatus.toActivate',
	CARD_STATUS_REQUESTED: 'cardStatus.requested',
	CARD_STATUS_ORDERED: 'cardStatus.ordered',
	CARD_STATUS_PRODUCED: 'cardStatus.produced',
	CARD_STATUS_FROZEN: 'cardStatus.frozen',
	CARD_STATUS_FAULTY: 'cardStatus.faulty',
	CARD_STATUS_ACTIVE: 'cardStatus.active',

	CARD_TYPE_VIRTUAL: 'cardType.virtual',
	CARD_TYPE_PHYSICAL: 'cardType.physical',

	PHYSICAL_CARD_STATUS_TO_ACTIVATE: 'physicalCardStatus.toActivate',

	DEBIT_CARD_USER_SECTION_TITLE: 'debitCardUser.sectionTitle',
	DEBIT_CARD_USER_SHOW_CARD_NUMBER: 'debitCardUser.showCardNumber',
	DEBIT_CARD_USER_SHOW_CARD_NUMBER_ERROR: 'debitCardUser.showCardNumberError',
	DEBIT_CARD_USER_SHOW_PIN: 'debitCardUser.showPin',
	DEBIT_CARD_USER_SHOW_PIN_ERROR: 'debitCardUser.showPinError',
	DEBIT_CARD_USER_ACTIVATE_CARD: 'debitCardUser.activateCard',
	DEBIT_CARD_USER_ACTIVATE_PHYSICAL_CARD: 'debitCardUser.activatePhysicalCard',
	DEBIT_CARD_USER_FREEZE_CARD: 'debitCardUser.freezeCard',
	DEBIT_CARD_USER_UNFREEZE_CARD: 'debitCardUser.unfreezeCard',
	DEBIT_CARD_USER_FREEZE_SUCCESS: 'debitCardUser.freezeSuccess',
	DEBIT_CARD_USER_FREEZE_ERROR: 'debitCardUser.freezeError',
	DEBIT_CARD_USER_ACTIVATE_SUCCESS: 'debitCardUser.activateSuccess',
	DEBIT_CARD_USER_ACTIVATE_ERROR: 'debitCardUser.activateError',
	DEBIT_CARD_USER_UNFREEZE_SUCCESS: 'debitCardUser.unfreezeSuccess',
	DEBIT_CARD_USER_UNFREEZE_ERROR: 'debitCardUser.unfreezeError',
	DEBIT_CARD_USER_EMPTY_TITLE: 'debitCardUser.emptyTitle',
	DEBIT_CARD_USER_EMPTY_DESCRIPTION: 'debitCardUser.emptyDescription',
	DEBIT_CARD_USER_MULTI_SECTION_TITLE: 'debitCardUser.multiSectionTitle',
	DEBIT_CARD_USER_CARD_UNKNOWN_STATUS: 'debitCardUser.cardUnknownStatus',
	DEBIT_CARD_USER_CARD_LOAD_ERROR: 'debitCardUser.cardLoadError',
	DEBIT_CARD_MOCK_ALT: 'debitCardMock.alt',
	DEBIT_CARD_MOCK_VALID_THRU: 'debitCardMock.validThru',

	DEBIT_CARDS_ACTIONS_SECTION_TITLE: 'debitCardsActions.sectionTitle',
	DEBIT_CARDS_ACTIONS_ADD_CARD: 'debitCardsActions.addCard',
	DEBIT_CARDS_ACTIONS_SEARCH_PLACEHOLDER: 'debitCardsActions.searchPlaceholder',
	DEBIT_CARDS_ACTIONS_FILTER_ARIA_LABEL: 'debitCardsActions.filterAriaLabel',
	DEBIT_CARDS_ACTIONS_TAB_ALL: 'debitCardsActions.tabAll',
	DEBIT_CARDS_ACTIONS_TAB_ACTIVE: 'debitCardsActions.tabActive',
	DEBIT_CARDS_ACTIONS_TAB_FROZEN: 'debitCardsActions.tabFrozen',
	DEBIT_CARDS_ACTIONS_TAB_IN_PROGRESS: 'debitCardsActions.tabInProgress',
	DEBIT_CARDS_ACTIONS_FORMER_EMPLOYEES: 'debitCardsActions.formerEmployees',
	DEBIT_CARDS_ACTIONS_BACK_TO_CARDS: 'debitCardsActions.backToCards',
	DEBIT_CARDS_ACTIONS_VIEWS: 'debitCardsActions.views',
	DEBIT_CARDS_ACTIONS_MORE: 'debitCardsActions.more',
	DEBIT_CARDS_COMPANY_FORMER_EMPLOYEES_HINT: 'debitCardsCompany.formerEmployeesHint',

	DEBIT_CARDS_COMPANY_SECTION_TITLE: 'debitCardsCompany.sectionTitle',
	DEBIT_CARDS_COMPANY_COL_NAME_AND_CARD_FORMAT: 'debitCardsCompany.columns.nameAndCardFormat',
	DEBIT_CARDS_COMPANY_COL_STATUS: 'debitCardsCompany.columns.status',
	DEBIT_CARDS_COMPANY_COL_CREATED_AT: 'debitCardsCompany.columns.createdAt',
	DEBIT_CARDS_COMPANY_CANCEL_CARD_ARIA_LABEL: 'debitCardsCompany.cancelCardAriaLabel',
	DEBIT_CARDS_COMPANY_FREEZE_CARD_ARIA_LABEL: 'debitCardsCompany.freezeCardAriaLabel',
	DEBIT_CARDS_COMPANY_UNFREEZE_CARD_ARIA_LABEL: 'debitCardsCompany.unfreezeCardAriaLabel',
	DEBIT_CARDS_COMPANY_FREEZE_CARD_SUCCESS: 'debitCardsCompany.freezeSuccess',
	DEBIT_CARDS_COMPANY_FREEZE_CARD_ERROR: 'debitCardsCompany.freezeError',
	DEBIT_CARDS_COMPANY_UNFREEZE_CARD_SUCCESS: 'debitCardsCompany.unfreezeSuccess',
	DEBIT_CARDS_COMPANY_UNFREEZE_CARD_ERROR: 'debitCardsCompany.unfreezeError',
	DEBIT_CARDS_COMPANY_REHIRE_BUTTON: 'debitCardsCompany.rehireButton',
	DEBIT_CARDS_COMPANY_REHIRE_ARIA_LABEL: 'debitCardsCompany.rehireAriaLabel',
	DEBIT_CARDS_COMPANY_REHIRE_SUCCESS: 'debitCardsCompany.rehireSuccess',
	DEBIT_CARDS_COMPANY_REHIRE_ERROR: 'debitCardsCompany.rehireError',
	DEBIT_CARDS_COMPANY_REHIRE_MODAL_TITLE: 'debitCardsCompany.rehireModal.title',
	DEBIT_CARDS_COMPANY_REHIRE_MODAL_DESCRIPTION: 'debitCardsCompany.rehireModal.description',
	DEBIT_CARDS_COMPANY_REHIRE_MODAL_CANCEL: 'debitCardsCompany.rehireModal.cancel',
	DEBIT_CARDS_COMPANY_REHIRE_MODAL_CONFIRM: 'debitCardsCompany.rehireModal.confirm',

	DEBIT_CARDS_COMPANY_CANCEL_MODAL_SECTION_TITLE: 'debitCardsCompany.cancelModal.sectionTitle',
	DEBIT_CARDS_COMPANY_CANCEL_MODAL_TITLE: 'debitCardsCompany.cancelModal.title',
	DEBIT_CARDS_COMPANY_CANCEL_MODAL_SUBTITLE: 'debitCardsCompany.cancelModal.subtitle',
	DEBIT_CARDS_COMPANY_CANCEL_MODAL_NOTIFICATION: 'debitCardsCompany.cancelModal.notification',
	DEBIT_CARDS_COMPANY_CANCEL_MODAL_CANCEL: 'debitCardsCompany.cancelModal.cancel',
	DEBIT_CARDS_COMPANY_CANCEL_MODAL_CONFIRM: 'debitCardsCompany.cancelModal.confirm',
	DEBIT_CARDS_COMPANY_CANCEL_CARD_SUCCESS: 'debitCardsCompany.cancelModal.cancelSuccess',
	DEBIT_CARDS_COMPANY_CANCEL_CARD_ERROR: 'debitCardsCompany.cancelModal.cancelError',

	DEBIT_CARDS_COMPANY_CREATE_MODAL_SECTION_TITLE: 'debitCardsCompany.createModal.sectionTitle',
	DEBIT_CARDS_COMPANY_CREATE_MODAL_TITLE: 'debitCardsCompany.createModal.title',
	DEBIT_CARDS_COMPANY_CREATE_MODAL_STEP_FORMAT: 'debitCardsCompany.createModal.steps.format',
	DEBIT_CARDS_COMPANY_CREATE_MODAL_STEP_EMPLOYEES: 'debitCardsCompany.createModal.steps.employees',
	DEBIT_CARDS_COMPANY_CREATE_MODAL_STEP_ADDRESS: 'debitCardsCompany.createModal.steps.address',
	DEBIT_CARDS_COMPANY_CREATE_MODAL_STEP_CONFIRMATION:
		'debitCardsCompany.createModal.steps.confirmation',
	DEBIT_CARDS_COMPANY_CREATE_MODAL_ADDRESS_LABEL: 'debitCardsCompany.createModal.addressLabel',
	DEBIT_CARDS_COMPANY_CREATE_MODAL_FORMAT_TITLE: 'debitCardsCompany.createModal.format.title',
	DEBIT_CARDS_COMPANY_CREATE_MODAL_FORMAT_SUBTITLE: 'debitCardsCompany.createModal.format.subtitle',
	DEBIT_CARDS_COMPANY_CREATE_MODAL_VIRTUAL_LABEL: 'debitCardsCompany.createModal.virtual.label',
	DEBIT_CARDS_COMPANY_CREATE_MODAL_VIRTUAL_DESCRIPTION:
		'debitCardsCompany.createModal.virtual.description',
	DEBIT_CARDS_COMPANY_CREATE_MODAL_PHYSICAL_LABEL: 'debitCardsCompany.createModal.physical.label',
	DEBIT_CARDS_COMPANY_CREATE_MODAL_PHYSICAL_DESCRIPTION:
		'debitCardsCompany.createModal.physical.description',
	DEBIT_CARDS_COMPANY_CREATE_MODAL_CANCEL: 'debitCardsCompany.createModal.cancel',
	DEBIT_CARDS_COMPANY_CREATE_MODAL_BACK: 'debitCardsCompany.createModal.back',
	DEBIT_CARDS_COMPANY_CREATE_MODAL_NEXT: 'debitCardsCompany.createModal.next',
	DEBIT_CARDS_COMPANY_CREATE_MODAL_CONFIRM: 'debitCardsCompany.createModal.confirm',
	DEBIT_CARDS_COMPANY_CREATE_MODAL_SUBMIT_ERROR: 'debitCardsCompany.createModal.submitError',

	DEBIT_CARDS_COMPANY_CREATE_MODAL_EMPLOYEES_COL_EMPLOYEE:
		'debitCardsCompany.createModal.employeesStep.colEmployee',
	DEBIT_CARDS_COMPANY_CREATE_MODAL_EMPLOYEES_SEARCH_PLACEHOLDER:
		'debitCardsCompany.createModal.employeesStep.searchPlaceholder',
	DEBIT_CARDS_COMPANY_CREATE_MODAL_EMPLOYEES_SELECT_ALL:
		'debitCardsCompany.createModal.employeesStep.selectAll',
	DEBIT_CARDS_COMPANY_CREATE_MODAL_EMPLOYEES_SELECTED_BADGE:
		'debitCardsCompany.createModal.employeesStep.selectedBadge',
	DEBIT_CARDS_COMPANY_CREATE_MODAL_EMPLOYEES_SELECT_ALL_ARIA:
		'debitCardsCompany.createModal.employeesStep.selectAllAria',

	DEBIT_CARDS_COMPANY_CREATE_MODAL_CONFIRMATION_TITLE:
		'debitCardsCompany.createModal.confirmationStep.title',
	DEBIT_CARDS_COMPANY_CREATE_MODAL_CONFIRMATION_DESC_1:
		'debitCardsCompany.createModal.confirmationStep.descriptionLine1',
	DEBIT_CARDS_COMPANY_CREATE_MODAL_CONFIRMATION_DESC_2:
		'debitCardsCompany.createModal.confirmationStep.descriptionLine2',

	DEBIT_CARDS_COMPANY_IDENT_MODAL_SECTION_TITLE: 'debitCardsCompany.identModal.sectionTitle',
	DEBIT_CARDS_COMPANY_IDENT_MODAL_TITLE: 'debitCardsCompany.identModal.title',
	DEBIT_CARDS_COMPANY_IDENT_MODAL_MESSAGE: 'debitCardsCompany.identModal.message',
	DEBIT_CARDS_COMPANY_IDENT_MODAL_LINK: 'debitCardsCompany.identModal.link',
	DEBIT_CARDS_COMPANY_IDENT_MODAL_CLOSE: 'debitCardsCompany.identModal.close',
	// fix-admin-unverified-logout: toast shown when POST /v1/user/authtoken fails (not the 300 loginURL case)
	DEBIT_CARDS_COMPANY_IDENT_MODAL_ERROR: 'debitCardsCompany.identModal.error',

	STEP_PROGRESS_SECTION_TITLE: 'stepProgress.sectionTitle',
	STEP_PROGRESS_SCHRITT: 'stepProgress.schritt',
	STEP_PROGRESS_PENDING: 'stepProgress.pending',
	STEP_PROGRESS_IN_PROGRESS: 'stepProgress.inProgress',
	STEP_PROGRESS_COMPLETED: 'stepProgress.completed',

	ENTITY_CARD_SECTION_TITLE: 'entityCard.sectionTitle',
	ENTITY_CARD_EDIT_BUTTON: 'entityCard.editButton',
	ENTITY_CARD_ADDRESS_INCOMPLETE: 'entityCard.addressIncomplete',

	ENTITY_CARD_ADDRESS_MODAL_TITLE: 'entityCard.addressModal.title',
	ENTITY_CARD_ADDRESS_MODAL_CLOSE: 'entityCard.addressModal.close',
	ENTITY_CARD_ADDRESS_MODAL_SAVE: 'entityCard.addressModal.save',
	ENTITY_CARD_ADDRESS_MODAL_COUNTRY: 'entityCard.addressModal.country',
	ENTITY_CARD_ADDRESS_MODAL_COUNTRY_PLACEHOLDER: 'entityCard.addressModal.countryPlaceholder',
	ENTITY_CARD_ADDRESS_MODAL_STREET: 'entityCard.addressModal.street',
	ENTITY_CARD_ADDRESS_MODAL_STREET_PLACEHOLDER: 'entityCard.addressModal.streetPlaceholder',
	ENTITY_CARD_ADDRESS_MODAL_ADDRESS_LINE1: 'entityCard.addressModal.addressLine1',
	ENTITY_CARD_ADDRESS_MODAL_ADDRESS_LINE1_PLACEHOLDER:
		'entityCard.addressModal.addressLine1Placeholder',
	ENTITY_CARD_ADDRESS_MODAL_ADDRESS_LINE2_COMPANY_HINT:
		'entityCard.addressModal.addressLine2CompanyHint',
	ENTITY_CARD_ADDRESS_MODAL_POSTAL_CODE: 'entityCard.addressModal.postalCode',
	ENTITY_CARD_ADDRESS_MODAL_POSTAL_CODE_PLACEHOLDER:
		'entityCard.addressModal.postalCodePlaceholder',
	ENTITY_CARD_ADDRESS_MODAL_CITY: 'entityCard.addressModal.city',
	ENTITY_CARD_ADDRESS_MODAL_CITY_PLACEHOLDER: 'entityCard.addressModal.cityPlaceholder',
	ENTITY_CARD_ADDRESS_MODAL_COUNTRY_GBR: 'entityCard.addressModal.countryGbr',
	ENTITY_CARD_ADDRESS_MODAL_COUNTRY_DEU: 'entityCard.addressModal.countryDeu',
	ENTITY_CARD_ADDRESS_MODAL_COUNTRY_ESP: 'entityCard.addressModal.countryEsp',
	ENTITY_CARD_ADDRESS_MODAL_COUNTRY_FRA: 'entityCard.addressModal.countryFra',
	ENTITY_CARD_ADDRESS_MODAL_COUNTRY_HRV: 'entityCard.addressModal.countryHrv',
	ENTITY_CARD_ADDRESS_MODAL_COUNTRY_ITA: 'entityCard.addressModal.countryIta',
	ENTITY_CARD_ADDRESS_MODAL_COUNTRY_LVA: 'entityCard.addressModal.countryLva',
	ENTITY_CARD_ADDRESS_MODAL_COUNTRY_NLD: 'entityCard.addressModal.countryNld',
	ENTITY_CARD_ADDRESS_MODAL_COUNTRY_POL: 'entityCard.addressModal.countryPol',
	ENTITY_CARD_ADDRESS_MODAL_COUNTRY_PRT: 'entityCard.addressModal.countryPrt',

	TOPUP_ORDERS_COMPANY_SECTION_TITLE: 'topupOrdersCompany.sectionTitle',
	TOPUP_ORDERS_COMPANY_ACTION_SECTION_TITLE: 'topupOrdersCompany.action.sectionTitle',
	TOPUP_ORDERS_COMPANY_ACTION_NEW_ORDER_BUTTON: 'topupOrdersCompany.action.newOrderButton',
	TOPUP_ORDERS_COMPANY_ACTION_FILTER_ARIA_LABEL: 'topupOrdersCompany.action.filterAriaLabel',
	TOPUP_ORDERS_COMPANY_ACTION_TAB_ALL: 'topupOrdersCompany.action.tabAll',
	TOPUP_ORDERS_COMPANY_ACTION_TAB_ACTIVE: 'topupOrdersCompany.action.tabActive',
	TOPUP_ORDERS_COMPANY_ACTION_TAB_INACTIVE: 'topupOrdersCompany.action.tabInactive',

	TOPUP_ORDERS_COMPANY_CREATE_SECTION_TITLE: 'topupOrdersCompany.create.sectionTitle',
	TOPUP_ORDERS_COMPANY_CREATE_TITLE: 'topupOrdersCompany.create.title',
	TOPUP_ORDERS_COMPANY_EDIT_TITLE: 'topupOrdersCompany.edit.title',
	TOPUP_ORDERS_COMPANY_CREATE_CANCEL: 'topupOrdersCompany.create.cancel',
	TOPUP_ORDERS_COMPANY_CREATE_BACK: 'topupOrdersCompany.create.back',
	TOPUP_ORDERS_COMPANY_CREATE_NEXT: 'topupOrdersCompany.create.next',
	TOPUP_ORDERS_COMPANY_CREATE_SUBMIT: 'topupOrdersCompany.create.submit',
	TOPUP_ORDERS_COMPANY_CREATE_SUBMIT_SUCCESS: 'topupOrdersCompany.create.submitSuccess',
	TOPUP_ORDERS_COMPANY_CREATE_SUBMIT_ERROR: 'topupOrdersCompany.create.submitError',
	TOPUP_ORDERS_COMPANY_CREATE_EMPLOYEES_INCOMPLETE_ERROR:
		'topupOrdersCompany.create.employeesIncompleteError',
	TOPUP_ORDERS_COMPANY_CREATE_STEP_FORMAT: 'topupOrdersCompany.create.steps.format',
	TOPUP_ORDERS_COMPANY_CREATE_STEP_DETAILS: 'topupOrdersCompany.create.steps.details',
	TOPUP_ORDERS_COMPANY_CREATE_STEP_EMPLOYEES: 'topupOrdersCompany.create.steps.employees',
	TOPUP_ORDERS_COMPANY_CREATE_STEP_CONFIRMATION: 'topupOrdersCompany.create.steps.confirmation',
	TOPUP_ORDERS_COMPANY_CREATE_STEP_FORMAT_TITLE: 'topupOrdersCompany.create.stepFormat.title',
	TOPUP_ORDERS_COMPANY_CREATE_STEP_FORMAT_SUBTITLE: 'topupOrdersCompany.create.stepFormat.subtitle',
	TOPUP_ORDERS_COMPANY_CREATE_SINGLE_LABEL: 'topupOrdersCompany.create.stepFormat.single.label',
	TOPUP_ORDERS_COMPANY_CREATE_SINGLE_DESCRIPTION:
		'topupOrdersCompany.create.stepFormat.single.description',
	TOPUP_ORDERS_COMPANY_CREATE_MONTHLY_LABEL: 'topupOrdersCompany.create.stepFormat.monthly.label',
	TOPUP_ORDERS_COMPANY_CREATE_MONTHLY_DESCRIPTION:
		'topupOrdersCompany.create.stepFormat.monthly.description',

	TOPUP_ORDERS_COMPANY_CREATE_STEP_DETAILS_BENEFIT_TYPE_LABEL:
		'topupOrdersCompany.create.stepDetails.benefitTypeLabel',
	TOPUP_ORDERS_COMPANY_CREATE_STEP_DETAILS_BENEFIT_TYPE_DESCRIPTION:
		'topupOrdersCompany.create.stepDetails.benefitTypeDescription',
	TOPUP_ORDERS_COMPANY_CREATE_STEP_DETAILS_BENEFIT_TYPE_PLACEHOLDER:
		'topupOrdersCompany.create.stepDetails.benefitTypePlaceholder',

	TOPUP_ORDERS_COMPANY_CREATE_STEP_DETAILS_COUNT_LABEL:
		'topupOrdersCompany.create.stepDetails.countLabel',
	TOPUP_ORDERS_COMPANY_CREATE_STEP_DETAILS_COUNT_BADGE:
		'topupOrdersCompany.create.stepDetails.countBadge',
	TOPUP_ORDERS_COMPANY_CREATE_STEP_DETAILS_AMOUNT_BADGE:
		'topupOrdersCompany.create.stepDetails.amountBadge',
	TOPUP_ORDERS_COMPANY_CREATE_STEP_DETAILS_AMOUNT_LABEL:
		'topupOrdersCompany.create.stepDetails.amountLabel',
	TOPUP_ORDERS_COMPANY_CREATE_STEP_DETAILS_AMOUNT_LABEL_MEAL:
		'topupOrdersCompany.create.stepDetails.amountLabelMeal',
	TOPUP_ORDERS_COMPANY_CREATE_STEP_DETAILS_NAME_LABEL:
		'topupOrdersCompany.create.stepDetails.nameLabel',
	TOPUP_ORDERS_COMPANY_CREATE_STEP_DETAILS_NAME_DESCRIPTION:
		'topupOrdersCompany.create.stepDetails.nameDescription',
	TOPUP_ORDERS_COMPANY_CREATE_STEP_DETAILS_NAME_PLACEHOLDER:
		'topupOrdersCompany.create.stepDetails.namePlaceholder',
	TOPUP_ORDERS_COMPANY_CREATE_STEP_DETAILS_COUNT_MAX_ERROR:
		'topupOrdersCompany.create.stepDetails.countMaxError',
	TOPUP_ORDERS_COMPANY_CREATE_STEP_DETAILS_AMOUNT_MAX_ERROR:
		'topupOrdersCompany.create.stepDetails.amountMaxError',

	TOPUP_ORDERS_COMPANY_CREATE_STEP_EMPLOYEES_POOL_TITLE:
		'topupOrdersCompany.create.stepEmployees.poolTitle',
	TOPUP_ORDERS_COMPANY_CREATE_STEP_EMPLOYEES_POOL_EMPTY:
		'topupOrdersCompany.create.stepEmployees.poolEmpty',
	TOPUP_ORDERS_COMPANY_CREATE_STEP_EMPLOYEES_SEARCH_PLACEHOLDER:
		'topupOrdersCompany.create.stepEmployees.searchPlaceholder',
	TOPUP_ORDERS_COMPANY_CREATE_STEP_EMPLOYEES_ASSIGN_ALL:
		'topupOrdersCompany.create.stepEmployees.assignAll',
	TOPUP_ORDERS_COMPANY_CREATE_STEP_EMPLOYEES_CLEAR_ALL:
		'topupOrdersCompany.create.stepEmployees.clearAll',
	TOPUP_ORDERS_COMPANY_CREATE_STEP_EMPLOYEES_ASSIGNED_TITLE:
		'topupOrdersCompany.create.stepEmployees.assignedTitle',
	TOPUP_ORDERS_COMPANY_CREATE_STEP_EMPLOYEES_COL_AMOUNT:
		'topupOrdersCompany.create.stepEmployees.colAmount',
	TOPUP_ORDERS_COMPANY_CREATE_STEP_EMPLOYEES_COL_DAYS:
		'topupOrdersCompany.create.stepEmployees.colDays',
	TOPUP_ORDERS_COMPANY_CREATE_STEP_EMPLOYEES_EMPTY_TITLE:
		'topupOrdersCompany.create.stepEmployees.emptyTitle',
	TOPUP_ORDERS_COMPANY_CREATE_STEP_EMPLOYEES_EMPTY_HINT:
		'topupOrdersCompany.create.stepEmployees.emptyHint',
	TOPUP_ORDERS_COMPANY_CREATE_STEP_EMPLOYEES_EMPLOYEE_COUNT:
		'topupOrdersCompany.create.stepEmployees.employeeCount',
	TOPUP_ORDERS_COMPANY_CREATE_STEP_EMPLOYEES_POOL_ERROR:
		'topupOrdersCompany.create.stepEmployees.poolError',
	TOPUP_ORDERS_COMPANY_CREATE_STEP_EMPLOYEES_INCOMPLETE_TITLE:
		'topupOrdersCompany.create.stepEmployees.incompleteTitle',
	TOPUP_ORDERS_COMPANY_CREATE_STEP_EMPLOYEES_INCOMPLETE_AMOUNT_DESC:
		'topupOrdersCompany.create.stepEmployees.incompleteAmountDesc',
	TOPUP_ORDERS_COMPANY_CREATE_STEP_EMPLOYEES_INCOMPLETE_DAYS_DESC:
		'topupOrdersCompany.create.stepEmployees.incompleteDaysDesc',
	TOPUP_ORDERS_COMPANY_CREATE_STEP_EMPLOYEES_ROW_AMOUNT_UNIT:
		'topupOrdersCompany.create.stepEmployees.row.amountUnit',
	TOPUP_ORDERS_COMPANY_CREATE_STEP_EMPLOYEES_ROW_AMOUNT_ARIA:
		'topupOrdersCompany.create.stepEmployees.row.amountAriaLabel',
	TOPUP_ORDERS_COMPANY_CREATE_STEP_EMPLOYEES_ROW_DAYS_ARIA:
		'topupOrdersCompany.create.stepEmployees.row.daysAriaLabel',
	TOPUP_ORDERS_COMPANY_CREATE_STEP_EMPLOYEES_ROW_REMOVE_ARIA:
		'topupOrdersCompany.create.stepEmployees.row.removeAriaLabel',
	TOPUP_ORDERS_COMPANY_CREATE_STEP_EMPLOYEES_ROW_ASSIGN_ARIA:
		'topupOrdersCompany.create.stepEmployees.row.assignAriaLabel',

	TOPUP_ORDERS_COMPANY_CREATE_STEP_CONFIRMATION_UPLOAD_DAY_LABEL:
		'topupOrdersCompany.create.stepConfirmation.uploadDayLabel',
	TOPUP_ORDERS_COMPANY_CREATE_STEP_CONFIRMATION_UPLOAD_DAY_DESC:
		'topupOrdersCompany.create.stepConfirmation.uploadDayDesc',
	TOPUP_ORDERS_COMPANY_CREATE_STEP_CONFIRMATION_EVERY_MONTH_ON:
		'topupOrdersCompany.create.stepConfirmation.everyMonthOn',
	TOPUP_ORDERS_COMPANY_CREATE_STEP_CONFIRMATION_DAY_PLACEHOLDER:
		'topupOrdersCompany.create.stepConfirmation.dayPlaceholder',
	TOPUP_ORDERS_COMPANY_CREATE_STEP_CONFIRMATION_REMINDER_LABEL:
		'topupOrdersCompany.create.stepConfirmation.reminderLabel',
	TOPUP_ORDERS_COMPANY_CREATE_STEP_CONFIRMATION_REMINDER_DESC:
		'topupOrdersCompany.create.stepConfirmation.reminderDesc',
	TOPUP_ORDERS_COMPANY_CREATE_STEP_CONFIRMATION_REMINDER_PLACEHOLDER:
		'topupOrdersCompany.create.stepConfirmation.reminderPlaceholder',
	TOPUP_ORDERS_COMPANY_CREATE_STEP_CONFIRMATION_NOTIFICATION_TITLE:
		'topupOrdersCompany.create.stepConfirmation.notificationTitle',
	TOPUP_ORDERS_COMPANY_CREATE_STEP_CONFIRMATION_NOTIFICATION_DESC:
		'topupOrdersCompany.create.stepConfirmation.notificationDesc',
	TOPUP_ORDERS_COMPANY_CREATE_STEP_CONFIRMATION_NOTIFICATION_DESC_SINGLE:
		'topupOrdersCompany.create.stepConfirmation.notificationDescSingle',
	TOPUP_ORDERS_COMPANY_CREATE_STEP_CONFIRMATION_MESSAGE_LABEL:
		'topupOrdersCompany.create.stepConfirmation.messageLabel',
	TOPUP_ORDERS_COMPANY_CREATE_STEP_CONFIRMATION_MESSAGE_DESC:
		'topupOrdersCompany.create.stepConfirmation.messageDesc',
	TOPUP_ORDERS_COMPANY_CREATE_STEP_CONFIRMATION_MESSAGE_PLACEHOLDER:
		'topupOrdersCompany.create.stepConfirmation.messagePlaceholder',
	TOPUP_ORDERS_COMPANY_CREATE_STEP_CONFIRMATION_EXECUTION_DATE_LABEL:
		'topupOrdersCompany.create.stepConfirmation.executionDateLabel',
	TOPUP_ORDERS_COMPANY_CREATE_STEP_CONFIRMATION_EXECUTION_DATE_DESC:
		'topupOrdersCompany.create.stepConfirmation.executionDateDesc',
	TOPUP_ORDERS_COMPANY_CREATE_STEP_CONFIRMATION_START_DATE_LABEL:
		'topupOrdersCompany.create.stepConfirmation.startDateLabel',
	TOPUP_ORDERS_COMPANY_CREATE_STEP_CONFIRMATION_START_DATE_DESC:
		'topupOrdersCompany.create.stepConfirmation.startDateDesc',

	TOPUP_ORDERS_COMPANY_CREATE_CANCEL_MODAL_TITLE: 'topupOrdersCompany.create.cancelModal.title',
	TOPUP_ORDERS_COMPANY_CREATE_CANCEL_MODAL_DESCRIPTION:
		'topupOrdersCompany.create.cancelModal.description',
	TOPUP_ORDERS_COMPANY_CREATE_CANCEL_MODAL_CLOSE: 'topupOrdersCompany.create.cancelModal.close',
	TOPUP_ORDERS_COMPANY_CREATE_CANCEL_MODAL_CONFIRM: 'topupOrdersCompany.create.cancelModal.confirm',

	TOPUP_ORDERS_COMPANY_TABLE_SECTION_TITLE: 'topupOrdersCompany.table.sectionTitle',
	TOPUP_ORDERS_COMPANY_TABLE_COL_NAME: 'topupOrdersCompany.table.columns.name',
	TOPUP_ORDERS_COMPANY_TABLE_COL_STATUS: 'topupOrdersCompany.table.columns.status',
	TOPUP_ORDERS_COMPANY_TABLE_COL_INTERVAL: 'topupOrdersCompany.table.columns.interval',
	TOPUP_ORDERS_COMPANY_TABLE_COL_CREATED_AT: 'topupOrdersCompany.table.columns.createdAt',
	TOPUP_ORDERS_COMPANY_TABLE_COL_AMOUNT: 'topupOrdersCompany.table.columns.amount',
	TOPUP_ORDERS_COMPANY_TABLE_EMPTY_TITLE: 'topupOrdersCompany.table.empty.title',
	TOPUP_ORDERS_COMPANY_TABLE_EMPTY_NO_BENEFITS_DESC:
		'topupOrdersCompany.table.empty.noBenefitsDesc',
	TOPUP_ORDERS_COMPANY_TABLE_EMPTY_NO_BENEFITS_LINK:
		'topupOrdersCompany.table.empty.noBenefitsLink',
	TOPUP_ORDERS_COMPANY_TABLE_EMPTY_HAS_BENEFITS_DESC:
		'topupOrdersCompany.table.empty.hasBenefitsDesc',

	INTERVAL_SINGLE: 'interval.single',
	INTERVAL_MONTHLY: 'interval.monthly',

	TOPUP_ORDERS_COMPANY_TABLE_OPEN_ORDER_ARIA: 'topupOrdersCompany.table.openOrderAria',

	TOPUP_ORDERS_COMPANY_STATUS_NEW: 'topupOrdersCompany.status.new',
	TOPUP_ORDERS_COMPANY_STATUS_OPEN: 'topupOrdersCompany.status.open',
	TOPUP_ORDERS_COMPANY_STATUS_PENDING: 'topupOrdersCompany.status.pending',
	TOPUP_ORDERS_COMPANY_STATUS_PROCESSING: 'topupOrdersCompany.status.processing',
	TOPUP_ORDERS_COMPANY_STATUS_ACTIVE: 'topupOrdersCompany.status.active',
	TOPUP_ORDERS_COMPANY_STATUS_PAUSED: 'topupOrdersCompany.status.paused',
	TOPUP_ORDERS_COMPANY_STATUS_COMPLETED: 'topupOrdersCompany.status.completed',
	TOPUP_ORDERS_COMPANY_STATUS_CANCELED: 'topupOrdersCompany.status.canceled',
	TOPUP_ORDERS_COMPANY_STATUS_REVERSED: 'topupOrdersCompany.status.reversed',

	TOPUP_ORDERS_COMPANY_PAUSE_SUCCESS: 'topupOrdersCompany.detail.pauseSuccess',
	TOPUP_ORDERS_COMPANY_PAUSE_ERROR: 'topupOrdersCompany.detail.pauseError',
	TOPUP_ORDERS_COMPANY_RESUME_SUCCESS: 'topupOrdersCompany.detail.resumeSuccess',
	TOPUP_ORDERS_COMPANY_RESUME_ERROR: 'topupOrdersCompany.detail.resumeError',
	TOPUP_ORDERS_COMPANY_DELETE_SUCCESS: 'topupOrdersCompany.detail.deleteSuccess',
	TOPUP_ORDERS_COMPANY_DELETE_ERROR: 'topupOrdersCompany.detail.deleteError',
	TOPUP_ORDERS_COMPANY_CANCEL_SUCCESS: 'topupOrdersCompany.detail.cancelSuccess',
	TOPUP_ORDERS_COMPANY_CANCEL_ERROR: 'topupOrdersCompany.detail.cancelError',

	TOPUP_ORDERS_COMPANY_DETAIL_SECTION_TITLE: 'topupOrdersCompany.detail.sectionTitle',
	TOPUP_ORDERS_COMPANY_DETAIL_TAB_DETAILS: 'topupOrdersCompany.detail.tabDetails',
	TOPUP_ORDERS_COMPANY_DETAIL_TAB_EMPLOYEES: 'topupOrdersCompany.detail.tabEmployees',
	TOPUP_ORDERS_COMPANY_DETAIL_TOTAL_VOLUME: 'topupOrdersCompany.detail.totalVolume',
	TOPUP_ORDERS_COMPANY_DETAIL_EMPLOYEES_LABEL: 'topupOrdersCompany.detail.employeesLabel',
	TOPUP_ORDERS_COMPANY_DETAIL_CLOSE: 'topupOrdersCompany.detail.close',
	TOPUP_ORDERS_COMPANY_DETAIL_PREV_ORDER: 'topupOrdersCompany.detail.prevOrder',
	TOPUP_ORDERS_COMPANY_DETAIL_NEXT_ORDER: 'topupOrdersCompany.detail.nextOrder',
	TOPUP_ORDERS_COMPANY_DETAIL_EDIT: 'topupOrdersCompany.detail.edit',
	TOPUP_ORDERS_COMPANY_DETAIL_TERMINATE: 'topupOrdersCompany.detail.terminate',
	TOPUP_ORDERS_COMPANY_DETAIL_PAUSE: 'topupOrdersCompany.detail.pause',
	TOPUP_ORDERS_COMPANY_DETAIL_RESUME: 'topupOrdersCompany.detail.resume',
	TOPUP_ORDERS_COMPANY_SUMMARY_CARD_ORDER_TITLE: 'topupOrdersCompany.summaryCardOrder.title',
	TOPUP_ORDERS_COMPANY_SUMMARY_CARD_ORDER_BENEFIT_TYPE:
		'topupOrdersCompany.summaryCardOrder.benefitType',
	TOPUP_ORDERS_COMPANY_SUMMARY_CARD_ORDER_ART: 'topupOrdersCompany.summaryCardOrder.art',
	TOPUP_ORDERS_COMPANY_SUMMARY_CARD_EMPLOYEE_TITLE: 'topupOrdersCompany.summaryCardEmployee.title',
	TOPUP_ORDERS_COMPANY_SUMMARY_CARD_EMPLOYEE_ACTIVE_COUNT:
		'topupOrdersCompany.summaryCardEmployee.activeCount',
	TOPUP_ORDERS_COMPANY_SUMMARY_CARD_EMPLOYEE_TOTAL_VOLUME:
		'topupOrdersCompany.summaryCardEmployee.totalVolume',
	TOPUP_ORDERS_COMPANY_DETAIL_CHARGE_DAY: 'topupOrdersCompany.detail.chargeDay',
	TOPUP_ORDERS_COMPANY_DETAIL_CHARGE_DAY_FORMAT: 'topupOrdersCompany.detail.chargeDayFormat',
	TOPUP_ORDERS_COMPANY_DETAIL_START_DATE: 'topupOrdersCompany.detail.startDate',
	TOPUP_ORDERS_COMPANY_DETAIL_MESSAGE: 'topupOrdersCompany.detail.message',
	TOPUP_ORDERS_COMPANY_DETAIL_REFERENCE: 'topupOrdersCompany.detail.reference',
	TOPUP_ORDERS_COMPANY_DETAIL_LAST_FULFILLMENT: 'topupOrdersCompany.detail.lastFulfillment',
	TOPUP_ORDERS_COMPANY_DETAIL_NEXT_FULFILLMENT: 'topupOrdersCompany.detail.nextFulfillment',
	TOPUP_ORDERS_COMPANY_DETAIL_LAST_FULFILLMENT_NONE: 'topupOrdersCompany.detail.lastFulfillmentNone',
	TOPUP_ORDERS_COMPANY_DETAIL_NEXT_FULFILLMENT_NONE: 'topupOrdersCompany.detail.nextFulfillmentNone',
	TOPUP_ORDERS_COMPANY_DETAIL_COPY_REFERENCE: 'topupOrdersCompany.detail.copyReference',
	TOPUP_ORDERS_COMPANY_DETAIL_DELETE: 'topupOrdersCompany.detail.delete',
	TOPUP_ORDERS_COMPANY_DETAIL_COMPLETED_LABEL: 'topupOrdersCompany.detail.completedLabel',
	TOPUP_ORDERS_COMPANY_DETAIL_DELETED_LABEL: 'topupOrdersCompany.detail.deletedLabel',
	TOPUP_ORDERS_COMPANY_DETAIL_REVERSED_LABEL: 'topupOrdersCompany.detail.reversedLabel',

	TOPUP_ORDERS_COMPANY_DELETE_MODAL_TITLE: 'topupOrdersCompany.deleteModal.title',
	TOPUP_ORDERS_COMPANY_DELETE_MODAL_DESCRIPTION: 'topupOrdersCompany.deleteModal.description',
	TOPUP_ORDERS_COMPANY_DELETE_MODAL_CLOSE: 'topupOrdersCompany.deleteModal.close',
	TOPUP_ORDERS_COMPANY_DELETE_MODAL_CONFIRM: 'topupOrdersCompany.deleteModal.confirm',

	TOPUP_ORDERS_COMPANY_CANCEL_MODAL_TITLE: 'topupOrdersCompany.cancelModal.title',
	TOPUP_ORDERS_COMPANY_CANCEL_MODAL_DESCRIPTION: 'topupOrdersCompany.cancelModal.description',
	TOPUP_ORDERS_COMPANY_CANCEL_MODAL_CLOSE: 'topupOrdersCompany.cancelModal.close',
	TOPUP_ORDERS_COMPANY_CANCEL_MODAL_CONFIRM: 'topupOrdersCompany.cancelModal.confirm',

	HEADER_NAV_HELP_FAQ: 'headerNav.helpFaq',
	HEADER_NAV_FALLBACK_NAME: 'headerNav.fallbackFullName',
	HEADER_NAV_FALLBACK_COMPANY: 'headerNav.fallbackCompany',
	HEADER_NAV_PRIVATE_MODE_LABEL: 'headerNav.privateModeLabel',
	HEADER_NAV_COMPANY_MODE_LABEL: 'headerNav.companyModeLabel',
	HEADER_NAV_SWITCH_TO: 'headerNav.switchTo',
	HEADER_NAV_OPEN_MENU: 'headerNav.openMenu',
	HEADER_NAV_CLOSE_MENU: 'headerNav.closeMenu',
	HEADER_NAV_PROFILE_LABEL: 'headerNav.profileLabel',
	HEADER_NAV_ALL_COMPANIES: 'headerNav.allCompanies',

	REMINDER_CALENDAR_PREV_MONTH: 'reminderCalendar.prevMonth',
	REMINDER_CALENDAR_NEXT_MONTH: 'reminderCalendar.nextMonth',
	REMINDER_CALENDAR_PREV_YEAR: 'reminderCalendar.prevYear',
	REMINDER_CALENDAR_NEXT_YEAR: 'reminderCalendar.nextYear',
	REMINDER_CALENDAR_DIALOG: 'reminderCalendar.dialog',

	TOPUPS_COMPANY_SECTION_TITLE: 'topupsCompany.sectionTitle',
	TOPUPS_COMPANY_ACTION_SECTION_TITLE: 'topupsCompany.action.sectionTitle',
	TOPUPS_COMPANY_ACTION_EXPORT: 'topupsCompany.action.export',
	TOPUPS_COMPANY_EXPORT_MODAL_TITLE: 'topupsCompany.exportModal.title',
	TOPUPS_COMPANY_EXPORT_MODAL_DESCRIPTION: 'topupsCompany.exportModal.description',
	TOPUPS_COMPANY_EXPORT_MODAL_CLOSE: 'topupsCompany.exportModal.close',
	TOPUPS_COMPANY_EXPORT_MODAL_EXPORT_CURRENT: 'topupsCompany.exportModal.exportCurrent',
	TOPUPS_COMPANY_EXPORT_MODAL_EXPORT_ALL: 'topupsCompany.exportModal.exportAll',
	TOPUPS_COMPANY_EXPORT_MODAL_LOADING: 'topupsCompany.exportModal.loading',
	TOPUPS_COMPANY_EXPORT_MODAL_LOAD_ERROR: 'topupsCompany.exportModal.loadError',
	TOPUPS_COMPANY_ACTION_DATE_RANGE: 'topupsCompany.action.dateRange',
	TOPUPS_COMPANY_ACTION_FILTER_BUTTON: 'topupsCompany.action.filterButton',
	TOPUPS_COMPANY_ACTION_FILTER_ARIA_LABEL: 'topupsCompany.action.filterAriaLabel',
	TOPUPS_COMPANY_ACTION_SEARCH_PLACEHOLDER: 'topupsCompany.action.searchPlaceholder',
	TOPUPS_COMPANY_FILTER_SECTION_TITLE: 'topupsCompany.filter.sectionTitle',
	TOPUPS_COMPANY_FILTER_RESET: 'topupsCompany.filter.reset',
	TOPUPS_COMPANY_FILTER_BENEFIT: 'topupsCompany.filter.benefit',
	TOPUPS_COMPANY_FILTER_TAX_RELIEF: 'topupsCompany.filter.taxRelief',
	TOPUPS_COMPANY_FILTER_ALLE: 'topupsCompany.filter.alle',

	TOPUPS_COMPANY_FILTER_BAR_SECTION_TITLE: 'topupsCompany.filterBar.sectionTitle',
	TOPUPS_COMPANY_FILTER_BAR_CLEAR: 'topupsCompany.filterBar.clear',
	TOPUPS_COMPANY_FILTER_BAR_REMOVE_ARIA: 'topupsCompany.filterBar.removeAria',

	TOPUPS_COMPANY_DATE_RANGE_PANEL_TITLE: 'topupsCompany.dateRange.panelTitle',
	TOPUPS_COMPANY_DATE_RANGE_FROM: 'topupsCompany.dateRange.from',
	TOPUPS_COMPANY_DATE_RANGE_TO: 'topupsCompany.dateRange.to',
	TOPUPS_COMPANY_DATE_RANGE_PLACEHOLDER: 'topupsCompany.dateRange.placeholder',
	TOPUPS_COMPANY_DATE_RANGE_RESET: 'topupsCompany.dateRange.reset',
	TOPUPS_COMPANY_DATE_RANGE_APPLY: 'topupsCompany.dateRange.apply',

	TOPUPS_COMPANY_TABLE_COL_FULL_NAME: 'topupsCompany.table.colFullName',
	TOPUPS_COMPANY_TABLE_COL_BENEFIT: 'topupsCompany.table.colBenefit',
	TOPUPS_COMPANY_TABLE_COL_TAX_RELIEF: 'topupsCompany.table.colTaxRelief',
	TOPUPS_COMPANY_TABLE_COL_DATE: 'topupsCompany.table.colDate',
	TOPUPS_COMPANY_TABLE_COL_AMOUNT: 'topupsCompany.table.colAmount',

	SHARED_SEARCH_PLACEHOLDER: 'shared.searchPlaceholder',
	SHARED_SEARCH_CLEAR_ARIA: 'shared.searchClearAria',
	SHARED_SORT_NAME_ASC: 'shared.sortNameAsc',
	SHARED_SORT_NAME_DESC: 'shared.sortNameDesc',
	SHARED_SORT_TOGGLE_ARIA: 'shared.sortToggleAria',
	SHARED_SORT_BY_ARIA: 'shared.sortByAria',
	SHARED_SORTED_ARIA: 'shared.sortedAria',
	SHARED_SORT_ASCENDING: 'shared.sortAscending',
	SHARED_SORT_DESCENDING: 'shared.sortDescending',
	SHARED_NOTIFICATION_CLOSE_ARIA: 'shared.notificationCloseAria',
	SHARED_TABLE_EMPTY_STATE: 'shared.tableEmptyState',

	APP_UPDATE_TITLE: 'appUpdate.title',
	APP_UPDATE_DESCRIPTION: 'appUpdate.description',
	APP_UPDATE_RELOAD: 'appUpdate.reload',
	APP_UPDATE_DISMISS_ARIA: 'appUpdate.dismissAria',

	DATE_INPUT_DAY_PLACEHOLDER: 'shared.dateInput.dayPlaceholder',
	DATE_INPUT_MONTH_PLACEHOLDER: 'shared.dateInput.monthPlaceholder',
	DATE_INPUT_YEAR_PLACEHOLDER: 'shared.dateInput.yearPlaceholder',
	DATE_INPUT_SEPARATOR: 'shared.dateInput.separator',
	DATE_INPUT_PAST_DATE_ERROR: 'shared.dateInput.pastDateError',

	PHONE_INPUT_SELECT_COUNTRY_ARIA: 'shared.phoneInput.selectCountryAria',

	SHARED_ERROR_GENERAL: 'shared.errorGeneral',
	SHARED_POPUP_BLOCKED_ERROR: 'shared.popupBlockedError',
	SHARED_RELOAD_PAGE_ARIA: 'shared.reloadPageAria',
	DISCARD_CHANGES_MODAL_TITLE: 'shared.discardChangesModal.title',
	DISCARD_CHANGES_MODAL_DESCRIPTION: 'shared.discardChangesModal.description',
	DISCARD_CHANGES_MODAL_DISCARD: 'shared.discardChangesModal.discard',
	DISCARD_CHANGES_MODAL_KEEP_EDITING: 'shared.discardChangesModal.keepEditing',
	LATIN_ONLY_INVALID: 'shared.latinOnlyInvalid',

	COMPANY_ADMIN_REMOVED: 'companyAdmin.removed',

	PAGE_TITLE_HOME: 'pageTitle.home',
	PAGE_TITLE_SIGN_IN: 'pageTitle.signIn',
};

export const validForm = {
	FIELD_REQUIRED: 'field.required',
	FIELD_SUCCESS: 'field.success',

	EMAIL_REQUIRED: 'email.required',
	EMAIL_INVALID: 'email.invalid',

	PASSWORD_REQUIRED: 'password.required',
	PASSWORD_INVALID: 'password.invalid',
	PASSWORD_NO_LOWERCASE: 'password.noLowercase',
	PASSWORD_NO_UPPERCASE: 'password.noUppercase',
	PASSWORD_NO_NUMBER: 'password.noNumber',
	PASSWORD_TOO_SHORT: 'password.tooShort',
	PASSWORD_TOO_LONG: 'password.tooLong',

	PHONE_REQUIRED: 'phone.required',
	PHONE_INVALID: 'phone.invalid',
	PHONE_INVALID_LENGTH: 'phone.invalidLength',

	COUNTRY_CODE_REQUIRED: 'countryCode.required',
	COUNTRY_CODE_INVALID: 'countryCode.invalid',

	NAME_INVALID: 'name.invalid',

	DATE_INVALID: 'date.invalid',
	DATE_FUTURE_NOT_ALLOWED: 'date.futureNotAllowed',

	POSTAL_CODE_INVALID: 'postalCode.invalid',

	ADDRESS_LINE1_INVALID: 'addressLine1.invalid',

	CITY_INVALID: 'city.invalid',

	AMOUNT_INVALID: 'amount.invalid',

	LATIN_ONLY_INVALID: 'latinOnly.invalid',
};
